import { useState } from "react";
import { Flex, Spinner, Devider } from "dash-ui";
import {
  BasicInfoResponse,
  useGetAppBasicInfoQuery,
} from "gql/generated.graphql";
import ConfirmTokenGenerationModal from "./components/ConfirmTokenGenerationModal";
import { ApiTokenSection } from "./components/ApiTokenSection";
import { AppIdSection } from "./components/AppIdSection";
import { useTranslation } from "react-i18next";
import { ApiUsageSection } from "./components/ApiUsageSection";

const ApiSection = () => {
  const { t } = useTranslation(["pages"]);

  const [hasToken, setHasToken] = useState<boolean | null>(null);
  const [appId, setAppId] = useState<string | null>(null);

  const handleApiResponse = (data: {
    getApiCredentialsBasicInfo: BasicInfoResponse;
  }) => {
    setAppId(data?.getApiCredentialsBasicInfo?.appId);
    setHasToken(data?.getApiCredentialsBasicInfo?.hasKey);
  };

  const handleApiError = () => {
    setAppId(t("pages:profilePage:api:noAppIdFoundMessage"));
  };

  const { refetch, loading } = useGetAppBasicInfoQuery({
    onCompleted: handleApiResponse,
    onError: handleApiError,
  });

  const handleRefetch = async () => {
    try {
      const { data } = await refetch();
      handleApiResponse(data);
    } catch (error) {
      handleApiError();
    }
  };

  return (
    <div className="w-full">
      {loading ? (
        <Flex w="100%" alignItems="center" justifyContent="center">
          <Spinner />
        </Flex>
      ) : (
        <div>
          <AppIdSection appId={appId} />
          <ApiTokenSection hasToken={hasToken} />
          <Devider w="100%" mt={4} />
          <ApiUsageSection appId={appId} />
          <ConfirmTokenGenerationModal
            refetchAppInfo={handleRefetch}
            hasToken={hasToken}
          />
        </div>
      )}
    </div>
  );
};

export default ApiSection;
